// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import PageHeader from "../shared/pageHeader/PageHeader";
// import Footer from "../shared/Footer";
// import Header from "../shared/header/Header";
// import { fetchData, fetchFormData } from "../../utils/options";
// import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
// import Member2Header from "./Member2Header";
// import MemberCreate from "./MemberCreate";

// const ViewMember = () => {
//   const { id } = useParams();
//   const [member, setMember] = useState([]);
//   const [loading, setLoading] = useState(true);

// const fetchmember = async () => {
//   const formData = new FormData();
//   formData.append("memberId", id); // or whatever your backend expects

//   const result = await fetchFormData("member/view", formData, "POST");

//   if (result && result.data) {
//     setMember(result.data);
//   }
// };

//   useEffect(() => {
//     fetchmember();
//   }, []);
//   return (
//     <>
//       <Header />
//       <NavigationMenu />
//       <main className="nxl-container">
//         <div className="nxl-content">
//           <PageHeader>
//             <Member2Header />
//           </PageHeader>

//           <div className="main-content">
//             <div className="row">
//               <div className="col-md-12">
//                 <div className="card shadow p-4">
//                   <div className="LoandetailsDiv">
//                     <div className="form-group Details uppercase-header">
//                       <h4>Member Code:</h4>
//                       <p>{member.member_code || "-"}</p>
//                     </div>

//                     <div className="form-group Details uppercase-header">
//                       <h4>Full Name:</h4>
//                       <p>{member.full_name || "-"}</p>
//                     </div>

//                     <div className="form-group Details uppercase-header">
//                       <h4>Email:</h4>
//                       <p>{member.email || "-"}</p>
//                     </div>

//                     <div className="form-group Details uppercase-header">
//                       <h4>Mobile:</h4>
//                       <p>{member.mobile || "-"}</p>
//                     </div>

//                     <div className="form-group Details uppercase-header">
//                       <h4>WhatsApp:</h4>
//                       <p>{member.whatsapp || "-"}</p>
//                     </div>

//                     <div className="form-group Details uppercase-header">
//                       <h4>Gender:</h4>
//                       <p>{member.gender || "-"}</p>
//                     </div>

//                     <div className="form-group Details uppercase-header">
//                       <h4>DOB:</h4>
//                       <p>{member.dob || "-"}</p>
//                     </div>

//                     <div className="form-group Details uppercase-header">
//                       <h4>Permanent Address:</h4>
//                       <p>{member.permanent_address || "-"}</p>
//                     </div>

//                     <div className="form-group Details uppercase-header">
//                       <h4>Permanent City:</h4>
//                       <p>{member.permanent_city || "-"}</p>
//                     </div>

//                     <div className="form-group Details uppercase-header">
//                       <h4>Permanent State:</h4>
//                       <p>{member.permanent_state || "-"}</p>
//                     </div>

//                     <div className="form-group Details uppercase-header">
//                       <h4>Permanent Pincode:</h4>
//                       <p>{member.permanent_pincode || "-"}</p>
//                     </div>

//                     <div className="form-group Details uppercase-header">
//                       <h4>Registered At:</h4>
//                       <p>{member.registered_at || "-"}</p>
//                     </div>

//                     <div className="form-group Details uppercase-header">
//                       <h4>Pan No:</h4>
//                       <p>{member.pan_no || "-"}</p>
//                     </div>

//                     <div className="form-group Details uppercase-header">
//                       <h4>Aadhaar Verified:</h4>
//                       <p>{member.is_aadhaar_verified === 1 ? "Yes" : "No"}</p>
//                     </div>

//                     <div className="form-group Details uppercase-header">
//                       <h4>Pan Verified:</h4>
//                       <p>{member.is_pan_verified === 1 ? "Yes" : "No"}</p>
//                     </div>

//                     <div className="form-group Details uppercase-header">
//                       <h4>Photo:</h4>
//                       <p>
//                         {member.photo ? (
//                           <img
//                             src={`https://yourdomain.com/uploads/photo/${member.photo}`}
//                             alt="Member"
//                             width="100"
//                           />
//                         ) : (
//                           "-"
//                         )}
//                       </p>
//                     </div>

//                     <div className="form-group Details uppercase-header">
//                       <h4>Aadhaar Photo:</h4>
//                       <p>
//                         {member.aadhaar_photo ? (
//                           <img
//                             src={`https://yourdomain.com/uploads/aadhaar/${member.aadhaar_photo}`}
//                             alt="Aadhaar"
//                             width="100"
//                           />
//                         ) : (
//                           "-"
//                         )}
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <Footer />
//         </div>
//       </main>
//     </>
//   );
// };

// export default ViewMember;

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import { fetchData, fetchFormData } from "../../utils/options";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import Member2Header from "./Member2Header";

const ViewMember = () => {
  const { id } = useParams();
  const [member, setMember] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchMember = async () => {
    try {
      const formData = new FormData();
      formData.append("memberId", id);
      formData.append("adminId", 1);
      formData.append("userId", 1);
      const result = await fetchFormData("member/list", formData, "POST");

      if (result && result.data) {
        setMember(result.data);
      }
    } catch (error) {
      console.error("Error fetching member:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMember();
  }, [id]);

  if (loading) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <Member2Header />
          </PageHeader>

          <div className="main-content">
            <div className="row">
              <div className="col-md-12">
                <div className="card shadow p-4">
                  <div className="LoandetailsDiv">
                    {[
                      { label: "Member Code", value: member.member_code },
                      { label: "Full Name", value: member.full_name },
                      { label: "Email", value: member.email },
                      { label: "Mobile", value: member.mobile },
                      { label: "WhatsApp", value: member.whatsapp },
                      { label: "Gender", value: member.gender },
                      { label: "DOB", value: member.dob },
                      {
                        label: "Permanent Address",
                        value: member.permanent_address,
                      },
                      { label: "Permanent City", value: member.permanent_city },
                      {
                        label: "Permanent State",
                        value: member.permanent_state,
                      },
                      {
                        label: "Permanent Pincode",
                        value: member.permanent_pincode,
                      },
                      { label: "Registered At", value: member.registered_at },
                      { label: "Pan No", value: member.pan_no },
                      {
                        label: "Aadhaar Verified",
                        value: member.is_aadhaar_verified === 1 ? "Yes" : "No",
                      },
                      {
                        label: "Pan Verified",
                        value: member.is_pan_verified === 1 ? "Yes" : "No",
                      },
                    ].map((field, idx) => (
                      <div
                        key={idx}
                        className="form-group Details uppercase-header"
                      >
                        <h4>{field.label}:</h4>
                        <p>{field.value || "-"}</p>
                      </div>
                    ))}

                    <div className="form-group Details uppercase-header">
                      <h4>Photo:</h4>
                      <p>
                        {member.photo ? (
                          <img
                            src={`https://yourdomain.com/uploads/photo/${member.photo}`}
                            alt="Member"
                            width="100"
                          />
                        ) : (
                          "-"
                        )}
                      </p>
                    </div>

                    <div className="form-group Details uppercase-header">
                      <h4>Aadhaar Photo:</h4>
                      <p>
                        {member.aadhaar_photo ? (
                          <img
                            src={`https://yourdomain.com/uploads/aadhaar/${member.aadhaar_photo}`}
                            alt="Aadhaar"
                            width="100"
                          />
                        ) : (
                          "-"
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      </main>
    </>
  );
};

export default ViewMember;
